import {React, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageSlider from '../components/ImageSlider';
import WhatsAppChat from '../components/WhatsAppButton';
import './Home.css';
import LimitedOffer from '../components/LimitedOffer';

const Home = () => {
  const primaryColor = '#019B9B';
  const secondaryColor = '#FF6B6B';
  const [reviews, setReviews] = useState([]);
  const sliderImages = [
    {
      id: 1,
      image: '/images/s_01.jpg',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      title: 'Pain-Free Dental Care in Bokundara, Piliyandala, Colombo',
      description: 'Bokundara Dental Surgery is a trusted dental clinic, offering professional and patient-friendly dental care with modern equipment, high standards of sterilization, and transparent pricing.',
      cta: 'Book Your Appointment'
    },
    {
      id: 2,
      image: '/images/s_02.jpg',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      title: 'Expert Dental Professionals',
      description: 'Highly qualified dentists with 15+ years of experience in advanced dentistry.',
      cta: 'Meet Our Team'
    },
    {
      id: 3,
      image: '/images/s_03.jpg',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      title: 'State-of-the-Art Facility',
      description: 'Modern equipment and technology for the best treatment outcomes.',
      cta: 'Tour Our Clinic'
    },
    {
      id: 4,
      image: '/images/s_02.jpg',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      title: 'Patient Comfort First',
      description: 'Relaxing environment designed for your comfort and peace of mind.',
      cta: 'Learn More'
    }
  ];

  const services = [
    { id: 1, icon: '/images/or_04.jpeg', title: 'General Dental \nCheck-ups', description: 'Routine dental check-ups help detect cavities gum disease, and other...', color: '#FFD700' },
    { id: 2, icon: '/images/or_09.jpeg', title: 'Dental \nFillings', description: 'We use high-quality tooth-coloured (composite) fillings to restore decayed or ...', color: '#87CEEB' },
    { id: 3, icon: '/images/or_08.jpeg', title: 'Scaling, Cleaning & \nPolishing', description: 'Professional scaling and polishing remove plaque, tartar, and stains that ...', color: '#90EE90' },
    { id: 4, icon: '/images/or_06.jpeg', title: 'Root Canal \nTreatments', description: 'Root canal treatment is performed to save infected or severely decayed ...', color: '#FFB6C1' },
    { id: 5, icon: '/images/or_05.jpeg', title: 'Oral & Minor Surgical \nProcedures', description: 'We perform minor oral surgical procedures such as surgical removal of wisdom...', color: '#DDA0DD' },
    { id: 6, icon: '/images/or_07.jpeg', title: 'Braces & Orthodontic \nTreatments', description: 'Orthodontic treatments help correct misaligned teeth and bite ...', color: '#F0E68C' }
  ];

  const whyChooseUs = [
    { icon: '👨‍⚕️', title: 'Expert dental \nsurgeons', description: 'Our clinic is led by highly qualified and experienced dental surgeons dedicated to delivering excellence in every aspect of care.' },
    { icon: '⏱️', title: 'Professional, patient-centred \ncare', description: 'We pride ourselves on providing compassionate, respectful, and patient-focused treatment in a calm and reassuring environment.' },
    { icon: '💰', title: 'Exceptional standards of \nsterilization and hygiene', description: 'We maintain the highest standards of cleanliness and strictly adhere to internationally recommended sterilization and infection-control protocols.' },
    { icon: '🏥', title: 'Advanced technology and \npremium materials', description: 'We use modern dental equipment and carefully selected, high-quality materials to ensure precise, durable, and aesthetically pleasing outcomes.' },
    { icon: '😊', title: 'Transparent and affordable \npricing', description: 'We offer high-quality dental care at fair and transparent rates, ensuring excellent value without compromising standards.' },
    { icon: '🕐', title: 'Flexible and extended \nclinic hours', description: 'For your convenience, we offer morning and evening appointments, including weekend sessions.' }
  ];

  const testimonials = [
    { name: 'Priya Sharma', title: 'Software Engineer', text: 'Amazing experience! The dentist was very professional and caring. Highly recommended!', rating: 5, image: '👩‍💼' },
    { name: 'Rajesh Kumar', title: 'Business Owner', text: 'Best dental clinic in town. Great service, friendly staff, and affordable prices.', rating: 5, image: '👨‍💼' },
    { name: 'Anjali Patel', title: 'Teacher', text: 'Very impressed with the quality of treatment. Will definitely come back!', rating: 5, image: '👩‍🏫' },
    { name: 'Vikram Singh', title: 'Accountant', text: 'Professional team, clean clinic, and pain-free procedures. Excellent!', rating: 5, image: '👨‍💼' }
  ];

  useEffect(() => {
    fetch("https://bokundaradentalclinic.com/api/reviews-list.php")
      .then((res) => res.json())
      .then((data) => setReviews(data.reviews || []))
      .catch((err) => console.error("Reviews load error:", err));
  }, []);

  return (
    <main className="home">
      <section className="hero-section">
        <ImageSlider images={sliderImages} primaryColor={primaryColor} secondaryColor={secondaryColor} />
      </section>

      {/* <section className="quick-cta">
        <div className="quick-cta-container">
          <button className="quick-btn quick-btn-primary" style={{ backgroundColor: primaryColor }} onClick={() => window.location.href = 'tel:+919876543210'}>
            <span className="btn-icon">📞</span>
            <span className="btn-text">Call Now</span>
          </button>
          <button className="quick-btn quick-btn-secondary" style={{ backgroundColor: secondaryColor }} onClick={() => window.location.href = 'https://wa.me/+919876543210?text=Hi%20I%20would%20like%20to%20book%20an%20appointment'}>
            <span className="btn-icon">📅</span>
            <span className="btn-text">Book Appointment</span>
          </button>
        </div>
      </section> */}

      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle">Comprehensive dental care solutions for your entire family</p>
          </div>
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-icon-container">
                  {typeof service.icon === 'string' && (service.icon.startsWith('/') || service.icon.startsWith('http')) ? (
                    // SHOW IMAGE for paths like '/images/or_01.jpeg'
                    <img 
                      src={service.icon} 
                      alt={`${service.title} icon`}
                      className="service-icon"
                      style={{ width: '220px', height: '100px', objectFit: 'cover', borderRadius: '12px' }}
                    />
                  ) : (
                    // SHOW EMOJI for '🦷', '🪥', etc.
                    <span className="service-icon" style={{ fontSize: '2.5rem' }}>
                      {service.icon}
                    </span>
                  )}
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <Link to="/services" className="service-link">Learn More →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose Bokundara <br/> Dental Surgery?</h2>
            <p className="section-subtitle">Excellence in every smile we create</p>
          </div>
          <div className="features-grid">
            {whyChooseUs.map((feature, index) => (
              <div key={index} className="feature-card">
                {/* <div className="feature-icon">{feature.icon}</div> */}
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="highlights-section">
        <div className="container">
          <div className="highlights-grid">
            <div className="highlight-box" style={{ backgroundColor: `${primaryColor}15` }}>
              <h3 className="highlight-number" style={{ color: primaryColor }}>15+</h3>
              <p className="highlight-label">Years of Experience</p>
            </div>
            <div className="highlight-box" style={{ backgroundColor: `${secondaryColor}15` }}>
              <h3 className="highlight-number" style={{ color: secondaryColor }}>5000+</h3>
              <p className="highlight-label">Happy Patients</p>
            </div>
            <div className="highlight-box" style={{ backgroundColor: `${primaryColor}15` }}>
              <h3 className="highlight-number" style={{ color: primaryColor }}>50+</h3>
              <p className="highlight-label">Successful Cases Monthly</p>
            </div>
            <div className="highlight-box" style={{ backgroundColor: `${secondaryColor}15` }}>
              <h3 className="highlight-number" style={{ color: secondaryColor }}>24/7</h3>
              <p className="highlight-label">Emergency Support</p>
            </div>
          </div>
        </div>
      </section> */}
      

      <section className="reviews-section">
        <h2 style={{paddingTop:'60px',paddingBottom:'20px'}}>What Our Patients Say</h2>
        <div class="testimonials-grid" style={{padding:'30px', paddingBottom:'60px'}}>
          {reviews.slice(0, 6).map((r) => (
          <div class="testimonial-card" key={r.id}>
          <div class="testimonial-header">
            <div class="testimonial-avatar">👩‍💼</div>
            <div class="testimonial-info">
              <h4 class="testimonial-name">{r.name}</h4>
              <p class="testimonial-title">{r.sourceUrl && (
                <a
                  href={r.sourceUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="review-link"
                >
                  View on Google
                </a>
              )}</p>
          </div>
          </div>
            <div class="testimonial-rating">{("★".repeat(r.rating || 0) + "☆☆☆☆☆").slice(0, 5)}</div>
            <p class="testimonial-text">{r.comment}</p>
          </div>
          ))}

          
        </div>
        {/* NEW: View All Reviews Link */}
    <div style={{ textAlign: "center", marginTop: "5px", marginBottom:"40px" }}>
      <p style={{ fontSize: "16px", color: "#303030", marginBottom: "10px" }}>
        To see all our reviews, please visit our Google page
      </p>
      <a
        href="https://www.google.com/maps/place/?q=place_id:ChIJjSvYThNP4joRUfEofb1c9ME" // REPLACE THIS with your actual Google Maps short link
        target="_blank"
        rel="noreferrer"
        className="btn btn-outline"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          borderColor: "#019B9B",
          color: "#019B9B",
          padding: "12px 25px",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "600"
        }}
      >
        <span style={{ fontSize: "18px" }}>G</span> Visit Google Page
      </a>
    </div>
      </section>

      {/* <section className="offer-banner" style={{ backgroundColor: primaryColor }}>
        <div className="container">
          <div className="offer-content">
            <h2 className="offer-title">Limited Time Offer!</h2>
            <p className="offer-subtitle">Get 20% off on your first appointment</p>
            <button className="btn btn-white" onClick={() => window.location.href = 'https://wa.me/+919876543210?text=I%20want%20to%20claim%20the%2020%25%20discount'}>
              Claim Offer Now
            </button>
          </div>
        </div>
      </section> */}
      <LimitedOffer />

      <section className="final-cta">
        <div className="container">
          <div className="cta-box">
            <h2>Ready for Your Perfect Smile?</h2>
            <p>Schedule your appointment today and experience the difference!</p>
            <div className="cta-buttons">
              <button className="btn btn-primary" style={{ backgroundColor: primaryColor }} onClick={() => window.location.href = 'https://wa.me/+94714680485?text=Hi%20I%20would%20like%20to%20book%20an%20appointment'}>
                📅 Book Now
              </button>
              <Link to="/contact" className="btn btn-outline" style={{ borderColor: primaryColor, color: primaryColor }}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      <WhatsAppChat />
    </main>
  );
};

export default Home;
